<div class="container">
    <div class="title-foro">Foros del Futuro</div>
    <div class="principal-summary">
        <ng-container *ngIf="t1 && t1.summary">{{t1.summary}}</ng-container>
    </div>
    <br>
    <app-carousel-pubs [data]="dataCarousel" [color]="'#3B69AE'"></app-carousel-pubs>
    <br>
    <div class="row mb-3">
        <!-- Buscador -->
        <div class="col-sm-4">
            <div class="input-group">
                <input type="text" id="searchInput" class="form-control select-custom" placeholder="Buscar"
                    autocomplete="off" #searchInputRef>
                <div class="input-group-append">
                    <button class="btn search-button" (click)="performSearch(searchInputRef.value)">
                        <i class="fa fa-search" style="color: aliceblue;"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class=" col-sm-4">
            <select class="form-select select-custom" id="select-tematic" #selectTematic
                (change)="selectedTematicChanged(selectTematic.value)">
                <option selected class="select-items" value="0">Temática</option>
                <option class="select-items" *ngFor="let tematic of tematic" [value]="tematic.title">
                    {{tematic.title}}
                </option>
            </select>
        </div>
        <div class=" col-sm-4">
            <select class="form-select select-custom" id="select-year" #selectYear
                (change)="selectedYearChanged(selectYear.value)">
                <option selected class="select-items" value="0">Año</option>
                <option class="select-items" *ngFor="let yearOption of yearOptions" [value]="yearOption">
                    {{ yearOption === 0 ? 'Todos' : yearOption }}
                </option>
            </select>
        </div>
    </div>
    <div *ngIf="!resultsEnct && filteredForos.length > 0" class="resultados-encontrados">
        Resultados encontrados
        <br>
        <br>
    </div>
    <div class="form-group row">
        <!--mostramos los foros-->
        <div class="col-sm-12">
            <div class="foros-grid">
                <ng-container *ngIf="resultsEnct">
                    <div class="col-sm-4 no-results-message">
                        No se encontraron resultados
                    </div>
                </ng-container>
                <ng-container *ngIf="!resultsEnct">
                    <div *ngFor="let foro of getDisplayedForos()" class="foro-item">
                        <a (click)="onForoClick(foro.id)">
                            <div class="foro-content">
                                <div class="foro-img">
                                    <img src="{{URL}}{{foro.img}}">
                                </div>
                                <div class="foro-details">
                                    <div class="foro-episode">{{ foro.episode}} {{foro.group }}:</div>
                                    <div class="foro-title">{{ foro.title }}</div>
                                </div>
                            </div>
                        </a>
                    </div>
                </ng-container>
            </div>
            <br>
            <!-- controles de paginación -->
            <nav aria-label="Page navigation" *ngIf="showPaginator">
                <ul class="pagination">
                    <li class="page-item" *ngFor="let pageNumber of getPageNumbers()">
                        <a class="page-link" href="javascript:void(0);" [class.page-number]="true"
                            [class.active]="isPageActive(pageNumber)" (click)="changePage(pageNumber)">
                            {{ pageNumber }}
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
    <br>
</div>